import { Styled } from "./styles";
import React from "react";
import Profile from "./profile-form";
import PasswordForm from "./password-form";
import constant from "@/utils/constant";
import useLocale from "@/context/locale";

const ProfileForm: React.FC = () => {
    useLocale(state => state.locale);
    const sectionSpacing = constant.GRID_SECTION_SPACING;
    
    return (
        <Styled.Card container direction="column" alignItems="center" spacing={sectionSpacing}>
            <Profile />
            <PasswordForm />
        </Styled.Card>
    );
};

export default ProfileForm;
